export const transactionList = 'admin/billing/transaction/list';
export const transactionReportList = 'admin/billing/transaction/report_list';
export const transactionRequisites = 'admin/billing/transaction/requisites_dic';
export const requisiteCreate = 'admin/billing/requisites/create';
export const requisiteUpdate = 'admin/billing/requisites/update';
export const requisiteGet = 'admin/billing/requisites/get';
export const writeoffCreate = 'admin/app/writeoff/create';
export const transferMoney = 'admin/app/investor/transfer_own_money';
export const autoRefillSettings = 'admin/app/wallet/auto_refill_settings';

// autoinvest & autofollow
export const investorProfile = 'admin/app/company/investor_portfolio';
export const investorProjectStats = 'admin/app/company/investor_project_stats';
export const investorProjectList = 'admin/app/investor_platform_profile/get_joined_projects';
export const autoInvestmentCreate = 'admin/app/auto_investments/create';
export const autoInvestmentCancel = 'admin/app/auto_investments/cancel';
export const autoInvestorFollowCreate = 'admin/app/investor_platform_profile/follow';
export const getPublicProfiles = 'admin/app/investor_platform_profile/get_public_profiles';
export const autoInvestmentsList = 'admin/app/auto_investments/list';
export const autoFollowList = 'admin/app/investor_platform_profile/follow_list';
export const autoFollowCancel = 'admin/app/investor_platform_profile/follow_cancel';
export const autoInvestmentsUpdate = 'admin/app/auto_investments/update';
export const autoFollowUpdate = 'admin/app/investor_platform_profile/follow_update';

export const getKeyRate = 'admin/billing/key_rate/get_history';
